import config from '@/utility/config';
import { timeRequest } from '@/utility/timeRequest';

import { getAxiosErrorMsg } from './helpers';
import adminProtectedAxiosRequest from './helpers/adminProtectedAxiosRequest';

const {
  communityApiBasePath,
  communityApiBasePathCdn,
  isBackendCdnEnabled
} = config;

export const getHomeAnnouncementData = async (communityId) => {
  const basePath = isBackendCdnEnabled
    ? communityApiBasePathCdn
    : communityApiBasePath;
  const apiPath = `${basePath}/api/v1/communities/${communityId}/home-announcements`;

  const { data, error } = await timeRequest(
    () => adminProtectedAxiosRequest.get(apiPath),
    'GET: home-announcements'
  );

  if (error) {
    return { data: null, error: getAxiosErrorMsg(error) };
  }
  return { data: data, error: null };
};

export const reportPost = async (communityId, postId) => {
  const path = `${communityApiBasePath}/api/v1/communities/${communityId}/announcement/report`;
  return await adminProtectedAxiosRequest.post(path, { _id: postId });
};

export const getUserPosts = async (communityId, status) => {
  const path = `${communityApiBasePath}/api/v1/communities/${communityId}/user/announcements?status=${status}&paginate=1&pageNum=1&pageSize=10`;
  return await adminProtectedAxiosRequest.get(path);
};
